<ng-container *ngIf="uploadManagerService.status$ | async as upload">
    <ng-container *ngIf="uploadManagerService.panelOpen$ | async">
        <div class="global-upload" *ngIf="upload.active">

        <!-- HEADER -->
        <div class="global-upload-header">

            <div class="global-upload-header__main">

                <i data-feather="upload-cloud"></i>

                <div>

                    <strong>

                        <ng-container *ngIf="upload.checking">
                            {{ 'COMMON.MESSAGES.CHECKING' | translate }}
                        </ng-container>

                        <ng-container
                                *ngIf="
                                !upload.checking &&
                                !upload.processing
                            ">

                            {{ 'COMMON.MESSAGES.UPLOADING' | translate }}

                        </ng-container>

                        <ng-container
                                *ngIf="
                                !upload.checking &&
                                upload.processing
                            ">

                            {{ 'COMMON.MESSAGES.PROCESSING' | translate }}

                        </ng-container>

                    </strong>


                    <small>
                        {{ 'COMMON.MESSAGES.COUNT' | translate:{ current: upload.current, total: upload.total } }}
                    </small>

                </div>

            </div>


            <!-- CONTROLES -->
            <div class="global-upload-header__actions">

                <!-- MINIMIZAR -->
                <button
                        type="button"
                        class="global-upload-action"
                        (click)="uploadManagerService.closePanel()"
                        [attr.aria-label]="'COMMON.UPLOAD.BUTTONS.MINIMIZE' | translate">
                    <i data-feather="minus"></i>
                </button>


                <!-- OCULTAR -->
                <button
                        type="button"
                        class="global-upload-action"
                        (click)="uploadManagerService.closePanel()"
                        [attr.aria-label]="'COMMON.UPLOAD.BUTTONS.HIDE' | translate">
                    <i data-feather="x"></i>
                </button>

            </div>

        </div>


        <!-- CONTENIDO COMPLETO -->
        <div>
            <!-- ARCHIVO ACTUAL -->
            <ng-container *ngIf="upload.currentFile">
                <div class="global-upload-file">
                    {{ upload.currentFile }}
                </div>

                <div class="global-upload-progress">
                    <div class="global-upload-progress-bar" [style.width.%]="upload.progress"></div>
                </div>
                <div class="global-upload-status">
                    <span *ngIf="!upload.processing">
                        {{ upload.progress }}%
                    </span>
                    <span class="global-upload-processing" *ngIf="upload.processing">
                        {{ 'COMMON.MESSAGES.PROCESSING_PROGRESS' | translate }}
                    </span>
                </div>
            </ng-container>

            <!-- OPCIONES PDF -->
            <div class="global-upload-pdf-options" *ngIf="getPdfOptions(upload.items) as pdfItems">
                <ng-container *ngIf="pdfItems.length > 0">
                    <div class="global-upload-conflicts-title">
                        Opciones de PDF
                    </div>

                    <div class="global-upload-pdf-item" *ngFor="let item of pdfItems">
                        <div class="global-upload-conflict-info">
                            <strong>{{ item.file.name }}</strong>

                            <span class="global-upload-conflict-path"
                                  *ngIf="item.relativePath && item.relativePath !== item.file.name">
                    {{ item.relativePath }}
                </span>
                        </div>

                        <div class="global-upload-pdf-actions">
                            <div class="custom-control custom-switch">
                                <input type="checkbox"
                                       class="custom-control-input"
                                       [id]="'book-view-' + item.id"
                                       [checked]="item.bookView"
                                       (change)="uploadManagerService.setBookView(item.id, $any($event.target).checked)">

                                <label class="custom-control-label" [for]="'book-view-' + item.id">
                                    Vista de libro
                                </label>
                            </div>

                            <button type="button"
                                    class="btn btn-sm btn-primary"
                                    (click)="uploadManagerService.confirmPdfOptions(item.id)">
                                Subir
                            </button>
                        </div>
                    </div>
                </ng-container>
            </div>

            <!-- DUPLICADOS -->
            <div class="global-upload-conflicts" *ngIf="upload.duplicates.length > 0">
                <div class="global-upload-conflicts-title">
                    {{ 'COMMON.MESSAGES.DUPLICATES_TITLE' | translate }}
                </div>
                <div class="global-upload-conflict" *ngFor="let item of upload.duplicates">
                    <div class="global-upload-conflict-info">
                        <strong>
                            {{ item.file.name }}
                        </strong>
                        <span class="global-upload-conflict-path" *ngIf="item.relativePath && item.relativePath !== item.file.name">
                            {{ item.relativePath }}
                        </span>
                        <small>
                            {{ 'COMMON.MESSAGES.FILE_EXISTS' | translate }}
                        </small>
                    </div>
                    <div class="custom-control custom-switch mb-1" *ngIf="isPdf(item)">
                        <input type="checkbox"
                               class="custom-control-input"
                               [id]="'duplicate-book-view-' + item.id"
                               [checked]="item.bookView"
                               (change)="uploadManagerService.setBookView(item.id, $any($event.target).checked)">

                        <label class="custom-control-label" [for]="'duplicate-book-view-' + item.id">
                            Vista de libro
                        </label>
                    </div>

                    <div class="global-upload-conflict-actions">
                        <button type="button" class="btn btn-sm btn-primary" (click)="uploadManagerService.replaceDuplicate(item.id)">
                            {{ 'COMMON.BUTTONS.REPLACE' | translate }}
                        </button>

                        <button type="button" class="btn btn-sm btn-outline-secondary" (click)="uploadManagerService.skipDuplicate(item.id)">
                            {{ 'COMMON.BUTTONS.SKIP' | translate }}
                        </button>
                    </div>
                </div>
            </div>

        </div>
        </div>
    </ng-container>
</ng-container>